import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=d9b1e7ae&scoped=true"
import script from "./UserMenu.ts?vue&type=script&lang=ts&external"
export * from "./UserMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=d9b1e7ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b1e7ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9b1e7ae')) {
      api.createRecord('d9b1e7ae', component.options)
    } else {
      api.reload('d9b1e7ae', component.options)
    }
    module.hot.accept("./UserMenu.vue?vue&type=template&id=d9b1e7ae&scoped=true", function () {
      api.rerender('d9b1e7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/User/components/UserMenu/UserMenu.vue"
export default component.exports